import useMediaQuery from "@mui/material/useMediaQuery";

/** Matches layout drawer breakpoint (961px). */
export default function useIsMobileViewport() {
  return useMediaQuery("(max-width:960px)");
}
